import { Link } from "react-router-dom";

export default function CTA() {
  return (
    <section className="cta-section">
      <div className="container">
        <div className="section-intro">
          <h2 className="cta-title">
            Ready for Professional RO Service?
          </h2>

          <p className="cta-description">
            Contact us today for reliable, expert RO solutions across Patna.
          </p>
        </div>

        <div className="cta-buttons">
          <a href="tel:9155365156" className="btn btn-accent">
            <i className="fas fa-phone"></i>
            <span>+91 9155365156</span>
          </a>

          <Link to="/" className="btn btn-contact">
            <i className="fas fa-envelope"></i>
            <span>Contact Us</span>
          </Link>
        </div>
      </div>
    </section>
  );
}